import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { map, Observable } from 'rxjs';
import { AuthService } from '../../../../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
    token$ = this.authService.token$;

    constructor(
        private readonly authService: AuthService,
        private readonly router: Router
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return this.token$.pipe(
        map((token) => {
            if (!token?.role) return true;

            // Handle both string and array cases
            let rolesArray: string[] = [];
            if (Array.isArray(token.role)) {
                rolesArray = token.role;
            } else if (typeof token.role === 'string') {
                rolesArray = token.role.includes(',') 
                    ? token.role.split(',').map(r => r.trim())
                    : [token.role];
            } else {
                return true;
            }

            if (!rolesArray || rolesArray.length === 0) return true;

            let permission = false;
            rolesArray.forEach((role: string) => {
                if (this.hasRole(route, role.trim())) permission = true;
            });

            if (!permission) this.router.navigate(['not-authorized']);

            return permission;
        })
        );
    }

    hasRole(
        component: ActivatedRouteSnapshot,
        role: string | undefined
    ): boolean {
        return component.data['roles'].find((r: string) => r === role) != null;
    }
}
